import React from 'react'
import { ConfirmationDialog } from '@paintscout/ui'
import { formatProcessingPaymentBullet, getPayments } from '@paintscout/util/builder'
import type { OptionsDocument, QuoteDocument } from 'paintscout'

interface OpenProcessingPaymentWarningDialogArgs {
  options: OptionsDocument
  quote: QuoteDocument
  openDialog: (component: any, props: any) => void
  dismissDialog: () => void
  onConfirm: () => void
}

export function openProcessingPaymentWarningDialog({
  options,
  quote,
  openDialog,
  dismissDialog,
  onConfirm
}: OpenProcessingPaymentWarningDialogArgs) {
  const processingPayments = getPayments({ quote }).filter((p) => p.status === 'processing')
  const isPlural = processingPayments.length > 1
  const intro = isPlural
    ? 'Your payments are currently being processed. Are you sure you want to make another payment?'
    : 'Your payment is currently being processed. Are you sure you want to make another payment?'
  const bullets = processingPayments.map((p) => formatProcessingPaymentBullet({ options, payment: p }))

  openDialog(ConfirmationDialog, {
    message: (
      <>
        <p style={{ margin: '0 0 8px' }}>{intro}</p>
        <ul style={{ margin: 0 }}>
          {bullets.map((b, i) => (
            <li key={i}>{b}</li>
          ))}
        </ul>
      </>
    ),
    yesLabel: 'Make Another Payment',
    onConfirm: () => {
      dismissDialog()
      onConfirm()
    },
    onCancel: dismissDialog
  })
}
